import { render, staticRenderFns } from "./OrdersProductEdit.vue?vue&type=template&id=1a474d54&scoped=true"
import script from "./OrdersProductEdit.vue?vue&type=script&lang=ts"
export * from "./OrdersProductEdit.vue?vue&type=script&lang=ts"
import style0 from "./OrdersProductEdit.vue?vue&type=style&index=0&id=1a474d54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a474d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a474d54')) {
      api.createRecord('1a474d54', component.options)
    } else {
      api.reload('1a474d54', component.options)
    }
    module.hot.accept("./OrdersProductEdit.vue?vue&type=template&id=1a474d54&scoped=true", function () {
      api.rerender('1a474d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrdersProductEdit.vue"
export default component.exports